<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToGrid"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{$t('Ga terug')}}
                        </ak-button>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Antwoorden')}}
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <tbody>
                                <tr v-for="answer in answers" :key="answer.id" class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i>{{ answer.question.question }}</i> <br />
                                        <b>{{ answer.value }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Deelnemer')}}
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <tbody>
                                <tr v-if="supplier" class="ak-table-row">
                                    <td class="ak-table-column">
                                        <a href="#" @click.prevent="openSupplierForm">
                                            {{ $t('Leverancier') }}: {{ supplier.title }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ participant.name }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ participant.email }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <router-view
            name="childview"
        />
    </div>
</template>

<script>
export default {
    name: 'MailLogOverview',
    data() {
        return {
            participant: null,
            answers: null,
            supplier: null,
            loading: false,
        }
    },
    methods: {
        async initialize() {
            this.loading = true;
            const result = await this.$get('/survey-answer-overview/' + this.$route.params.hashId);
            if (result.success) {
                this.participant = result.data.participant;
                this.answers = result.data.answers;
                this.supplier = result.data.supplier;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({name: 'grid', params:{bundle: 'survey-participants', gridDefinition: 'grid'}});
        },
        openSupplierForm() {
            this.$router.push({name: 'survey-answers-form', params:{bundle: 'supplier', definition: 'form', objectId: this.supplier.hashId}});
        }
    },
    created() {
        this.initialize();
    }
}
</script>
